<div ref="element">
	<slot/>
</div>
